import { StyleSheet } from 'react-native';

export type LessonGeneratorEmbedProps = {
  uri: string;
  containerStyle?: object;
};

export const lessonGeneratorEmbedStyles = StyleSheet.create({
  wrapper: {
    width: '100%',
    minHeight: 200,
    borderRadius: 10,
    overflow: 'hidden',
    backgroundColor: '#fff',
  },
  webview: {
    flex: 1,
    width: '100%',
    minHeight: 200,
    backgroundColor: 'transparent',
  },
});
